const services = [
  {
    icon: 'ri-scissors-line',
    title: 'Classic Haircut',
    description: 'Precision cuts tailored to your style and personality',
    price: '$40',
    image: 'https://static.readdy.ai/image/c1d0616d0c190b59a0ba1f5a87b1a045/2b3fe4b8bf8c124208016cceef5f5838.jpeg'
  },
  {
    icon: 'ri-contrast-drop-line',
    title: 'Beard Grooming',
    description: 'Precise edge-ups and line work for clean, sharp definition',
    price: '$40',
    image: 'https://static.readdy.ai/image/c1d0616d0c190b59a0ba1f5a87b1a045/27e3c9a5fdc6be13c9f126a5eecf11b2.jpeg'
  },
  {
    icon: 'ri-user-star-line',
    title: 'Hot Towel Shave',
    description: 'Traditional straight razor shave with premium products',
    price: '$40',
    image: 'https://static.readdy.ai/image/c1d0616d0c190b59a0ba1f5a87b1a045/6325befad47ca5aa937ab9ddd97aa17e.jpeg'
  },
  {
    icon: 'ri-magic-line',
    title: 'Hair Design',
    description: 'Creative patterns and designs for a unique style',
    price: '$50',
    image: 'https://static.readdy.ai/image/c1d0616d0c190b59a0ba1f5a87b1a045/f0dcdf63df8ae6c9444ba3c7fc7dd666.jpeg'
  },
  {
    icon: 'ri-parent-line',
    title: 'Kids Haircut',
    description: 'Patient and friendly service for young clients',
    price: '$28',
    image: 'https://static.readdy.ai/image/c1d0616d0c190b59a0ba1f5a87b1a045/430fa6bfa45bf8474a85ef893358edb7.jpeg'
  },
  {
    icon: 'ri-vip-crown-line',
    title: 'Premium Package',
    description: 'Presidential cut with hot towels and steam for the ultimate grooming experience',
    price: '$85',
    image: 'https://static.readdy.ai/image/c1d0616d0c190b59a0ba1f5a87b1a045/c9dec354646c9422dec6d1c31b5745dd.jpeg'
  }
];

export default function Services() {
  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-black mb-4">My Services</h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Professional grooming services tailored to bring out your best look
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-gray-50 rounded-2xl overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer"
            >
              <div className="h-64 overflow-hidden">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-8">
                <div className="w-16 h-16 bg-amber-500 rounded-full flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-3xl text-black`}></i>
                </div>
                <h3 className="text-2xl font-bold text-black mb-4">{service.title}</h3>
                <p className="text-gray-600 leading-relaxed">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
